module.exports = {"data":{"EventQuery":{"frontmatter":{"events":[{"title":"Aircraft Interiors Expo","startDate":"4/02/19","date":"April 02-04, 2019","location":"Hamburg, Germany","link":"http://www.aircraftinteriorsexpo.com"},{"title":"ZigBee Alliance Members Meeting","startDate":"6/24/19","date":"June 24-27, 2019","location":"Porto, Portugal.","link":"http://www.zigbee.org"},{"title":"NXP FTF Connects","startDate":"6/12/19","date":"June 12-13, 2019","location":"Santa Clara, CA.","link":"http://www.nxp.com"}]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 125
// module chunks = 60335399758886 114276838955818